/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = _1 (1)
 * 
 * 401130001 = _2 (2)
 * 
 * 401130002 = _3 (3)
 * 
 * 401130003 = _4 (4)
 * 
 * 401130004 = _5 (5)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceBewertung {
 _1 = 401130000,
 _2 = 401130001,
 _3 = 401130002,
 _4 = 401130003,
 _5 = 401130004
}

marker([
    "Enum.GlobalEnumsAceBewertung._1",
    "Enum.GlobalEnumsAceBewertung._2",
    "Enum.GlobalEnumsAceBewertung._3",
    "Enum.GlobalEnumsAceBewertung._4",
    "Enum.GlobalEnumsAceBewertung._5"
]);

export namespace GlobalEnumsAceBewertung
{
    class DataSets
    {
        static GlobalEnumsAceBewertungDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("_1", 401130000, "1"),
            new EnumValue("_2", 401130001, "2"),
            new EnumValue("_3", 401130002, "3"),
            new EnumValue("_4", 401130003, "4"),
            new EnumValue("_5", 401130004, "5"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceBewertungDataSet;
    }
}
